import React from "react";
import { SwissDateField } from "@/components/SwissDateInput";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";

/** Iter308: Kinder (Vorname, Geburtsdatum, in Ausbildung) – Zulage berechnet das ERP nach Kanton automatisch. */
export function ChildrenEditor({ value, onChange, testIdPrefix = "children" }) {
  const list = Array.isArray(value) ? value : [];
  const update = (i, patch) => onChange(list.map((c, idx) => (idx === i ? { ...c, ...patch } : c)));
  const age = (bd) => {
    if (!bd) return null;
    const b = new Date(bd); const n = new Date();
    let a = n.getFullYear() - b.getFullYear();
    if (n.getMonth() < b.getMonth() || (n.getMonth() === b.getMonth() && n.getDate() < b.getDate())) a -= 1;
    return a;
  };
  return (
    <div className="space-y-2" data-testid={`${testIdPrefix}-editor`}>
      <div className="flex items-center justify-between">
        <Label className="text-sm">Kinder (für Kinder-/Ausbildungszulage)</Label>
        <Button type="button" variant="outline" size="sm" onClick={() => onChange([...list, { first_name: "", birth_date: "", in_education: false }])}
          data-testid={`${testIdPrefix}-add-button`}>
          <Plus className="h-3.5 w-3.5 mr-1" /> Kind hinzufügen
        </Button>
      </div>
      {list.length === 0 && <p className="text-xs text-slate-400">Keine Kinder erfasst.</p>}
      {list.map((c, i) => {
        const a = age(c.birth_date);
        return (
          <div key={i} className="grid grid-cols-12 gap-2 items-center rounded-md border border-slate-200 p-2" data-testid={`${testIdPrefix}-row-${i}`}>
            <Input className="col-span-4" placeholder="Vorname" value={c.first_name || ""} onChange={(e) => update(i, { first_name: e.target.value })}
              data-testid={`${testIdPrefix}-name-${i}`} />
            <SwissDateField wrapClassName="col-span-4"  value={c.birth_date || ""} onChange={(e) => update(i, { birth_date: e.target.value })}
              data-testid={`${testIdPrefix}-birth-${i}`} />
            <label className={`col-span-3 flex items-center gap-1.5 text-xs ${a !== null && a < 16 ? "text-slate-400" : "text-slate-700"}`}>
              <input type="checkbox" checked={!!c.in_education} disabled={a !== null && a < 16}
                onChange={(e) => update(i, { in_education: e.target.checked })} data-testid={`${testIdPrefix}-edu-${i}`} />
              in Ausbildung{a !== null ? ` (${a} J.)` : ""}
            </label>
            <button type="button" className="col-span-1 text-slate-400 hover:text-rose-600" onClick={() => onChange(list.filter((_, idx) => idx !== i))}
              data-testid={`${testIdPrefix}-remove-${i}`} aria-label="Kind entfernen">
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        );
      })}
      <p className="text-[11px] text-slate-500">
        Bis 16 Jahre Kinderzulage, 16–25 Jahre in Ausbildung Ausbildungszulage – Ansatz gemäss Kanton der Firma (BSV 2026), automatisch berechnet.
      </p>
    </div>
  );
}
